/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';

function CommentUserDateInfo(props) {
  const { selectRowData } = props;
  return (
    <div data-testid='userinfo-tab'>
      <div className='form-wrapper db'>
        <form autoComplete='off'>
          <div className='tab-holder outline_border'>
            <div className='row'>
              <div className='col-6 col-md-3'>
                <div className='form-wrapper vertical-wrapper'>
                  <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                    <TextField
                      label='Created By'
                      id='CreatedBy'
                      fullWidth
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      inputProps={{ maxLength: 20, id: 'CreatedBy' }}
                      value={selectRowData && selectRowData.creatorId}
                    />
                  </div>
                </div>
              </div>
              <div className='col-6 col-md-3'>
                <div className='form-wrapper vertical-wrapper'>
                  <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                    <TextField
                      label='Created on'
                      id='CreatedOn'
                      fullWidth
                      placeholder=''
                      inputProps={{ id: 'CreatedOn' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={selectRowData && selectRowData.crateDate}
                    />
                  </div>
                </div>
              </div>
              <div className='col-6 col-md-3'>
                <div className='form-wrapper vertical-wrapper'>
                  <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                    <TextField
                      label='Last Updated By'
                      id='lastUpdatedBy'
                      fullWidth
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      inputProps={{ maxLength: 20, id: 'lastUpdatedBy' }}
                      value={selectRowData && selectRowData.lastUpdateUserId}
                    />
                  </div>
                </div>
              </div>
              <div className='col-6 col-md-3'>
                <div className='form-wrapper vertical-wrapper'>
                  <div className='mui-custom-form with-select input-md override-width-95'>
                    <TextField
                      label='Last Updated On'
                      id='lastUpdatedOn'
                      fullWidth
                      placeholder=''
                      inputProps={{ id: 'lastUpdatedOn' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={selectRowData && selectRowData.lastUpdateDt}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CommentUserDateInfo;
